/**
 * 初始化webrtc
 * 创建webrtc 对象
 */
import config from "@/config/config";
import util from "@/utils";
import store from "../";
import { Message } from "element-ui";

let devices = "";
//初始化webrtc
export const initWebRtc = ({ state, commit, dispatch }) => {
  return new Promise((res, rej) => {
    state.client = WebRTC2.createClient({
      appkey: config.appkey,
      debug: true,
    });
    res("ok");
    setListener(state, commit);
  });
};
//加入房间
export const joinRoom = ({ state, commit, dispatch }, info) => {
  const client = state.client;
  const { channelName, uid,} = info;
  const obj = {
    channelName,
    uid: Number(uid),
    token: "",
  };
  client
    .join(obj)
    .then((obj) => {
      dispatch("createLocalStream", { uid: Number(uid) });
      commit("ASYNC_USER_UID", Number(uid));
    })
    .catch((err) => {
      console.log("error===", err);
    });
};
const setListener = (state, commit) => {
  let { client, remoteStream } = state;
  client.on("peer-online", (evt) => {
    commit("ASYNC_LEAVE_ROOM", false);
  });
  client.on("peer-leave", (evt) => {
    commit("ASYNC_LEAVE_ROOM", true);
  });
  client.on("stream-added", (evt) => {
    let _remoteStream = evt.stream;
    state.isRemoteCloseVideo = false;
    if (
      state.remoteStream &&
      state.remoteStream.getId() !== state.remoteStream.getId()
    ) {
      // remoteStream = _remoteStream;
      return;
    } else {
      remoteStream = _remoteStream;
    }
    subscribe(client, remoteStream);
  });
  client.on("stream-removed", (evt) => {
    var remoteStream = evt.stream;
    remoteStream.stop();
    state.isRemoteCloseVideo = true;
    commit("ASYNC_REMOTE_STREAM", "");
  });
  client.on("stream-subscribed", (evt) => {
    var remoteStream = evt.stream;
    //用于播放对方视频画面的div节点
    const div = document.getElementById("remote");
    remoteStream
      .play(div)
      .then(() => {
        console.warn("播放视频");
        remoteStream.setRemoteRenderMode({
          // 设置视频窗口大小
          // width: 160,
          height: 240,
          // width: div.clientWidth,
          // height: div.clientHeight,
          cut: true, // 是否裁剪
          // cut: false // 是否裁剪
        });
      })
      .catch((err) => {
        console.warn("播放对方视频失败了: ", err);
      });
  });
};

//创建本地音视频
export const createLocalStream = ({ state, commit, dispatch }, info) => {
  const { uid } = info;
  const params = {
    uid,
    audio: true, //是否启动mic
    video: true, //是否启动camera
    screen: false, // 是否启动屏幕共享
  };
  state.localStream = WebRTC2.createStream(params);
  state.localStream.setVideoProfile({
    resolution: WebRTC2.VIDEO_QUALITY_720p, //设置视频分辨率
    frameRate: WebRTC2.CHAT_VIDEO_FRAME_RATE_15, //设置视频帧率
  });
  state.localStream.setAudioProfile("speech_low_quality");
  initLocalStream(state);
};
export const destroy = ({ state, commit }) => {
  const { localStream } = state;
  localStream.destroy();
  WebRTC2.destroy();
};
export const setOrRelieveSilence = ({ state, commit }, info) => {
  const { localStream } = state;
  const { status, isOpen } = info;
  return new Promise(async (res, rej) => {
    if (status) {
      localStream
        .close({
          type: "audio",
        })
        .then((data) => {
          console.log("成功", data);
          res(data);
        })
        .catch((err) => {
          console.log("错误", err);
          rej(err);
        });
    } else {
      if (!localStream) {
        Message.error({
          message: "本地音频输出设备错误",
        });
        return;
      }
      console.log("打开mic");
      localStream
        .open({
          type: "audio",
        })
        .then((data) => {
          console.log("success");
          res(data);
        })
        .catch(async (err) => {
          rej(err);
        });
    }
  });
};
export const stopOrOpenVideo = ({ state, commit }, info) => {
  const { localStream } = state;
  const { status, isOpen } = info;
  return new Promise(async (res, rej) => {
    if (status) {
      localStream
        .close({
          type: "video",
        })
        .then((data) => {
          res(data);
        })
        .catch((err) => rej(err));
    } else {
      if (!localStream) {
        Message.error({
          message: "本地视频输出设备错误",
        });
        return;
      }
      localStream
        .open({
          type: "video",
        })
        .then(() => {
          const div = document.getElementById("local");
          localStream.play(div);
          localStream.setLocalRenderMode({
            height: 240,
            cut: true,
          });
          res();
        })
        .catch(async (err) => {
          rej(err);
        });
    }
  });
};
//初始化
const initLocalStream = (state, device) => {
  state.localStream
    .init()
    .then(() => {
      console.warn("音视频初始化完成，播放本地视频");
      let div = document.getElementById("local");
      state.localStream.play(div);
      state.localStream.setLocalRenderMode({
        width: div.clientWidth,
        height: div.clientHeight,
        cut: false,
      });
      publish(state);
    })
    .catch((err) => rej(err));
};
//发布本段流
const publish = (state) => {
  state.client
    .publish(state.localStream)
    .then(() => {
      console.warn("本地 publish 成功");
    })
    .catch((err) => {
      console.log("err:", err);
    });
};
//订阅
const subscribe = (client, remoteStream) => {
  remoteStream.setSubscribeConfig({
    audio: true,
    video: true,
  });
  client
    .subscribe(remoteStream)
    .then(() => {
    })
    .catch((err) => {
    });
};

//创建信令
export const createSingLing = ({ state, commit, dispatch }, channelName) => {
  const { nim } = state;
  const param = {
    type: 2,
    channelName,
    ext: "",
  };
  return nim.signalingCreate(param);
};
//加入信令
export const joinSingLing = ({ state, commit, dispatch }, info) => {
  const { uid, channelId, attachExt } = info;
  const { nim } = state;
  const param = {
    channelId,
    offlineEnabled: false,
    attachExt,
    uid: Number(uid),
  };
  nim.signalingJoin(param);
};
//邀请加入
export const inviteSingLing = ({ state, commit, dispatch }, info) => {
  const { channelId, account, requestId, attachExt } = info;
  console.log(info);
  const { nim } = state;
  const pushInfo = {
    needPush: true,
    pushTitle: "title",
    pushContent: "你收到了邀请",
    pushPayload: { from: 111 },
    needBadge: true,
  };
  const param = {
    channelId,
    account,
    requestId,
    attachExt,
    pushInfo,
  };
  return nim.signalingInvite(param);
};
//离开信令
export const leaveSignaLing = ({ state, commit, dispatch }, info) => {
  const { nim } = state;
  const { channelId, channelName } = info;
  const param = {
    channelId,
    channelName,
    offlineEnabled: true,
    // attachExt,
  };
  return nim.signalingLeave(param);
};
//关闭信令
export const closeSignaLing = ({ state, commit, dispatch }, channelId) => {
  const { nim } = state;
  const param = {
    channelId,
    offlineEnabled: true,
    ext: "",
  };
  return nim.signalingClose(param);
};

export const queryChannelInfo = ({ state, commit, dispatch }, channelName) => {
  const { nim } = state;
  return nim.signalingGetChannelInfo({
    channelName: channelName,
  });
};

// 取消邀请
export const cancelInvite = ({ state, commit, dispatch }, info) => {
  const { nim } = state;
  const param = {
    channelId: info.channelId,
    account: info.account,
    requestId: info.requestId,
  };
  return nim.signalingCancel(param);
};
//接受邀请
export const acceptInvite = ({ state, commit, dispatch }, info) => {
  const { nim } = state;
  const param = {
    channelId: info.channelId,
    account: info.account,
    requestId: info.requestId,
  };
  return nim.signalingAccept(param);
};
//拒绝邀请
export const rejectInvite = ({ state, commit, dispatch }, info) => {
  const { nim } = state;
  const param = {
    channelId: info.channelId,
    account: info.account,
    requestId: info.requestId,
  };
  return nim.signalingReject(param);
};
export const signalCall = ({ state, commit, dispatch }, info) => {
  const { nim } = state;
  const pushInfo = {
    needPush: true,
    pushTitle: "呼叫邀请",
    pushContent: "邀请您加入房间",
    pushPayload: "{}",
    needBadge: true,
  };

  const param = {
    type: 2,
    channelName: info.channelName,
    uid: info.uid,
    account: info.account,
    requestId: info.requestId,
    offlineEnabled: true,
    pushInfo: pushInfo,
  };
  return nim.signalingCall(param);
};
//监听
export const signalingNotifyHandler = (event) => {
  console.log("signalingOnlineNotify: ", event);
  const {
    eventType,
    channelName,
    channelId,
    creator,
    from,
    to,
    requestId,
    attachExt,
  } = event;
  store.dispatch("setListenRoomData", {
    eventType,
    channelName,
    channelId,
    creator,
    from,
    to,
    requestId,
    attachExt,
  });
  store.dispatch("setRoomStatus", true);
};
export const setChannelId = ({ state, commit, dispatch }, channelId) => {
  commit("ASYNC_CHANNELID", channelId);
};
export const setListenRoomData = ({ state, commit, dispatch }, data) => {
  console.log(data);
  commit("ASYNC_LISTENROOM_DATA", data);
};
export const setRoomStatus = ({ state, commit, dispatch }, status) => {
  commit("ASYNC_ROOM_STATUS", status);
};
export const startAudio = ({ state, commit, dispatch }) => {
  const { localStream } = state;
  localStream.getAudioStream();
};
export const resetRoom = ({ state, commit, dispatch }) => {
  console.log(2);
  const { localStream } = state;
  if (!localStream) return;
  Promise.all([
    localStream.close({ type: "video" }),
    localStream.close({ type: "audio" }),
  ])
    .then(() => {
      localStream.stop();
      localStream.destroy();
      commit("ASYNC_LOCAL_STREAM", "");
      commit("ASYNC_REMOTE_STREAM", "");
      console.info("停止推送自定义流成功！");
    })
    .catch((err) => {
      console.error("停止推送自定义流失败: ", err);
    });
};
export const leave = ({ state, commit }) => {
  const { client } = state;
  console.log(1);
  client && client.leave();
};
